
import type { DayOfWeek } from '../types';

export const getWeekStartDate = (date: Date, startDayIndex: number = 1): Date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    const diff = d.getDate() - ((day - startDayIndex + 7) % 7);
    return new Date(d.setDate(diff));
};

export const getWeekDates = (startDate: Date): Date[] => {
    const dates: Date[] = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(startDate);
        d.setDate(d.getDate() + i);
        dates.push(d);
    }
    return dates;
};

export const formatDateYYYYMMDD = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatDayAndDate = (date: Date): { day: string, date: string, dayLong: string } => {
    const day = date.toLocaleDateString('en-US', { weekday: 'short' });
    const dayLong = date.toLocaleDateString('en-US', { weekday: 'long' });
    const dateNum = date.getDate().toString();
    return { day, date: dateNum, dayLong };
};

export const formatDateRange = (startDate: Date): string => {
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    const startDay = startDate.toLocaleDateString('en-US', { weekday: 'long' });
    const endDay = endDate.toLocaleDateString('en-US', { weekday: 'long' });
    const startMonth = startDate.toLocaleDateString('en-US', { month: 'short' });
    const endMonth = endDate.toLocaleDateString('en-US', { month: 'short' });

    if (startMonth === endMonth) {
        return `${startDay}, ${startMonth} ${startDate.getDate()} - ${endDay}, ${endDate.getDate()}, ${startDate.getFullYear()}`;
    } else {
        return `${startDay}, ${startMonth} ${startDate.getDate()} - ${endDay}, ${endMonth} ${endDate.getDate()}, ${startDate.getFullYear()}`;
    }
};

export const getDayOfWeekFromDate = (date: Date): DayOfWeek => {
    return date.toLocaleDateString('en-US', { weekday: 'long' }) as DayOfWeek;
}

export const calculateHours = (start: string, end: string): number => {
    if (!start || !end) return 0;
    const [sH, sM] = start.split(':').map(Number);
    const [eH, eM] = end.split(':').map(Number);
    
    let diff = (eH * 60 + eM) - (sH * 60 + sM);
    if (diff < 0) diff += 24 * 60; // Handle overnight shifts
    
    return Number((diff / 60).toFixed(2));
};

export const calculateMinutesDiff = (time1: string, time2: string): number => {
    if (!time1 || !time2) return 0;
    const [h1, m1] = time1.split(':').map(Number);
    const [h2, m2] = time2.split(':').map(Number);
    
    let diff = (h1 * 60 + m1) - (h2 * 60 + m2);
    // Note: This doesn't handle overnight for simple time comparison, 
    // but for start times it's usually fine.
    return diff;
};